import { z } from 'zod';

export const OneDriveSyncSettingsSchema = z.object({
  enabled: z.boolean(),
});

export type OneDriveSyncSettings = z.infer<typeof OneDriveSyncSettingsSchema>;

export const UserPreferencesSchema = z.object({
  autojoin: z.boolean(),
  oneDriveSync: OneDriveSyncSettingsSchema.optional(),
});

export type UserPreferences = z.infer<typeof UserPreferencesSchema>;
